<template>
  <!-- 底部 tabbar 线性图标:stroke=currentColor 继承 .van-tabbar-item 文字色
       (未激活 var(--vk-t2) / 激活 var(--vk-brand)),无需 PNG 双资产切换 -->
  <svg
    class="vk-tab-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- menu:宫格 -->
    <g v-if="name === 'menu'">
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
    </g>
    <!-- activity:礼物(优惠/Promotions) -->
    <g v-else-if="name === 'activity'">
      <rect x="4" y="11.5" width="16" height="9" rx="1.2" />
      <rect x="3" y="7.5" width="18" height="4" rx="1" />
      <path d="M12 7.5v13" />
      <path d="M12 7.5C10.5 4 6 4 6 6.4c0 1.6 3 1.5 6 1.1" />
      <path d="M12 7.5C13.5 4 18 4 18 6.4c0 1.6-3 1.5-6 1.1" />
    </g>
    <!-- home:房子 -->
    <g v-else-if="name === 'home'">
      <path d="M4 11.5 12 4.5l8 7" />
      <path d="M6.5 9.8v9.7h11V9.8" />
      <path d="M10 19.5v-5h4v5" />
    </g>
    <!-- lottery:彩球+星 -->
    <g v-else-if="name === 'lottery'">
      <circle cx="12" cy="12" r="8.5" />
      <path
        fill="currentColor"
        stroke="none"
        d="M12 7.6l1.3 2.8 3 .35-2.2 2.05.6 3-2.7-1.55-2.7 1.55.6-3-2.2-2.05 3-.35z"
      />
    </g>
    <!-- recharge:钱包+入金箭头(Deposit) -->
    <g v-else-if="name === 'recharge'">
      <path d="M12 2.2v4.1" />
      <path d="M10.2 4.6 12 6.3l1.8-1.7" />
      <rect x="3.5" y="8" width="17" height="12" rx="2" />
      <path d="M20.5 12h-4.5a2 2 0 0 0 0 4h4.5" />
    </g>
    <!-- mine:人形 -->
    <g v-else-if="name === 'mine'">
      <circle cx="12" cy="8" r="3.8" />
      <path d="M4.5 20c.8-4.2 3.9-6.3 7.5-6.3s6.7 2.1 7.5 6.3" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TabBarIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.vk-tab-icon {
  width: 24px;
  height: 24px;
  display: block;
}
</style>
